import { lzSAtomWithLocalStorage } from '@lz-store/services';

const lzSLayoutNavOpenAtom = lzSAtomWithLocalStorage('layoutNavOpenState', false);

export default lzSLayoutNavOpenAtom;
